import { render, staticRenderFns } from "./admin_articles_by_tag.vue?vue&type=template&id=c37ad3d8&scoped=true"
import script from "./admin_articles_by_tag.vue?vue&type=script&lang=js"
export * from "./admin_articles_by_tag.vue?vue&type=script&lang=js"
import style0 from "./admin_articles_by_tag.vue?vue&type=style&index=0&id=c37ad3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37ad3d8",
  null
  
)

export default component.exports